import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';

export class ZRPElementsVisibilityInViewportApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.Search_0_results;

  constructor(private action: GATrackingEventType) {}

  getPayload(): any {
    return {
      action: this.action,
      element: '',
    };
  }
}
